export default {
  meta: {
    title: '作战地图'
  }
};
